<template>
  <v-app>
    <!-- You can have a global header/nav here -->
    <v-main>
      <!-- THIS is where routed pages will appear -->
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* global styles if needed */
@import url('https://fonts.googleapis.com/css2?family=Geist:wght@100..900&display=swap');
body {
  font-family: "Geist", Helvetica, sans-serif sans-serif;
}
</style>
